// src/components/user/controltower/StatusFooter.jsx
import React from 'react';
import { Loader2, TruckIcon, CheckCircle, Zap } from 'lucide-react';

function StatusFooter({ deliveryPoints, expressPoints = [] }) {

  const regularEncamino  = deliveryPoints.filter(d => d.status === 'encamino').length;
  const regularPending   = deliveryPoints.filter(d => d.status === 'pending').length;
  const expressEncamino  = expressPoints.filter(d => d.status === 'encamino').length;
  const expressPending   = expressPoints.filter(d => d.status === 'pending').length;

  const allRegularDone = deliveryPoints.length > 0 && deliveryPoints.every(
    d => ['entregado', 'cancelado', 'rechazado'].includes(d.status)
  );
  const allExpressDone = expressPoints.length > 0 && expressPoints.every(
    d => ['entregado', 'cancelado', 'rechazado'].includes(d.status)
  );
  const allDone = allRegularDone && allExpressDone && (deliveryPoints.length + expressPoints.length) > 0;

  if (allDone) {
    return (
      <div className="flex-shrink-0 bg-brand-green text-white shadow-lg z-30 px-4 py-3">
        <div className="flex items-center justify-center gap-2">
          <CheckCircle className="w-5 h-5" />
          <p className="text-sm font-bold font-montserrat">Servicio finalizado — Todas las entregas completadas</p>
        </div>
      </div>
    );
  }

  const hasActivity = regularEncamino > 0 || regularPending > 0 || expressEncamino > 0 || expressPending > 0;

  if (!hasActivity) {
    return (
      <div className="flex-shrink-0 bg-slate-200 text-slate-700 shadow-lg z-30 px-4 py-3">
        <div className="flex items-center justify-center gap-2">
          <p className="text-sm font-bold font-montserrat">Sin entregas activas</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex-shrink-0 bg-white border-t border-slate-200 shadow-lg z-30 px-4 py-2">
      <div className="flex items-center justify-center gap-4 flex-wrap">

        {/* Regular summary */}
        {(regularEncamino > 0 || regularPending > 0) && (
          <div className="flex items-center gap-1.5">
            <TruckIcon className="w-4 h-4 text-brand-primary" />
            <span className="text-xs font-semibold text-slate-700 font-montserrat">
              Lima:
            </span>
            {regularEncamino > 0 && (
              <span className="text-xs bg-blue-100 text-blue-700 px-1.5 py-0.5 rounded-full font-montserrat font-semibold">
                {regularEncamino} en camino
              </span>
            )}
            {regularPending > 0 && (
              <span className="text-xs bg-orange-100 text-orange-700 px-1.5 py-0.5 rounded-full font-montserrat font-semibold">
                {regularPending} pendiente
              </span>
            )}
          </div>
        )}

        {/* Divider */}
        {(regularEncamino > 0 || regularPending > 0) && (expressEncamino > 0 || expressPending > 0) && (
          <span className="text-slate-300">|</span>
        )}

        {/* Express summary */}
        {(expressEncamino > 0 || expressPending > 0) && (
          <div className="flex items-center gap-1.5">
            <Zap className="w-4 h-4 text-brand-green" />
            <span className="text-xs font-semibold text-slate-700 font-montserrat">
              Express:
            </span>
            {expressEncamino > 0 && (
              <span className="text-xs bg-brand-green/15 text-brand-green px-1.5 py-0.5 rounded-full font-montserrat font-semibold">
                {expressEncamino} en camino
              </span>
            )}
            {expressPending > 0 && (
              <span className="text-xs bg-orange-100 text-orange-700 px-1.5 py-0.5 rounded-full font-montserrat font-semibold">
                {expressPending} pendiente
              </span>
            )}
          </div>
        )}

        {/* Processing spinner */}
        <Loader2 className="w-4 h-4 text-slate-400 animate-spin" />
      </div>
    </div>
  );
}

export default StatusFooter;